/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ScheduleTranslatorDebuggerResponse } from '../../models/schedule-translator-debugger-response';

export interface GetScheduleTranslatorDebugger$Params {
  location_id: string;

/**
 * solution date, yyyy-MM-dd
 */
  date: string;
}

export function getScheduleTranslatorDebugger(http: HttpClient, rootUrl: string, params: GetScheduleTranslatorDebugger$Params, context?: HttpContext): Observable<StrictHttpResponse<ScheduleTranslatorDebuggerResponse>> {
  const rb = new RequestBuilder(rootUrl, getScheduleTranslatorDebugger.PATH, 'get');
  if (params) {
    rb.path('location_id', params.location_id, {});
    rb.query('date', params.date, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ScheduleTranslatorDebuggerResponse>;
    })
  );
}

getScheduleTranslatorDebugger.PATH = '/locations/{location_id}/schedule-translator-debugger';
